import { Button, Modal } from 'antd';
import { useUnit } from 'effector-react';
import style from './CreateConfirmModa.module.css';
import {
  $confirmModal,
  $liteBusiness,
  getNewLocationEv,
  resetConfirmModalEv,
  sendCreateLitePresetFx,
  toggleIsPresetEv,
} from '../../../models/rbpLiteModel/index.js';
import payment_business_types from '../../../data/payment_business_types.json';
import { $tourOpen, incStepEv } from '../../../models/educationModel/index.js';

function CreateConfirmModal() {
  const liteBusiness = useUnit($liteBusiness);
  const getNewLocation = useUnit(getNewLocationEv);
  const onCancel = useUnit(resetConfirmModalEv);
  const confirmModal = useUnit($confirmModal);
  const pending = useUnit(sendCreateLitePresetFx.pending);
  const tourOpen = useUnit($tourOpen);
  const resetConfirmModal = useUnit(resetConfirmModalEv);
  const incStep = useUnit(incStepEv);
  const toggleIsPreset = useUnit(toggleIsPresetEv);

  let businessTitle = '';
  for (const item of payment_business_types) {
    const sub = item.subcategories.find(
      (subItem) =>
        subItem.uuid ===
        `t${liteBusiness.business}pt${liteBusiness.sub_business}`
    );
    if (sub) {
      businessTitle = sub.subtype;
    }
  }

  const onConfirm = () => {
    if (tourOpen) {
      resetConfirmModal();
      toggleIsPreset();
      incStep();
    } else {
      getNewLocation(confirmModal);
    }
  };

  return (
    <Modal open={!!confirmModal} closable={false} footer={null} centered>
      <div className={style.title}>
        Создать отчет по этой локации для типа бизнеса: {businessTitle}
      </div>
      <div className={style.buttons_wrapper}>
        <Button type="primary" onClick={onConfirm} loading={pending}>
          Создать
        </Button>{' '}
        <Button onClick={onCancel} disabled={pending}>
          Отмена
        </Button>
      </div>
    </Modal>
  );
}

export default CreateConfirmModal;
